import React from "react"
import { graphql } from "gatsby"
import BackgroundImage from 'gatsby-background-image'
import Navigation from "../components/navigation"
import styled from "styled-components"
import SEO from "../components/seo"
import RelatedBlogs from "../components/relatedblog"
import Footer from "../components/footer"
import pg from "../dist/img/pg.png"
import Layout from "../components/layout"
const HeroBackgroundImage = styled(BackgroundImage)`
                opacity: 1 !important;
                `;
const PaddedDiv = styled.div`
        padding-top:1.41em;
        padding-bottom: 1.41em;`;

const BlogImg = styled.img`
        max-height:150px;`;
export default function Template({
  data, // this prop will be injected by the GraphQL query below.
}) {
  const { markdownRemark } = data // data.markdownRemark holds your post data
  const { frontmatter, html } = markdownRemark
  let featuredImgFluid = frontmatter.featuredImage.childImageSharp.fluid
  return (
    <Layout>
    <div className="main-container">
    <SEO title={frontmatter.title}></SEO>
    <Navigation/>

    <section className="space--sm">
        
            {/* <div className="text-center" data-overlay="5">
                <HeroBackgroundImage
          Tag="section"
          className="height-60"
          fluid={featuredImgFluid}
        >

        </HeroBackgroundImage>
                
            </div> */}
          <section class="space--sm">
        <div className="container">
            <div className="row">
            <h2 className="article__title text-center">{frontmatter.title}</h2> <p className="lead text-center">{frontmatter.date} </p>
                <div className="col-sm-12 col-md-8 col-md-offset-2">
                    <div className="row text-center">
                        <div className="testimonial">
                                <BlogImg alt="Image"
                                     src={pg}/>
                            <h4><strong> By Prajakta Gogate</strong><br/>Manifestation Coach</h4>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>
          <div className="container ">
              <div className="row">

                  <div className="col-sm-10 col-md-10 col-sm-offset-1 col-md-offset-1 space-md text-justify">
                      <PaddedDiv
                      className="blog-post-content"
                      dangerouslySetInnerHTML={{ __html: html }}
                      />
                  </div>
              </div>
              
          </div>
          
    </section>
    <section>
        <div className="container">
            <div className="row">
                <div className="col-sm-12 col-md-8 col-md-offset-2">
                    <div className="row text-center">
                        <div className="testimonial">
                        <BlogImg alt="Image"
                                     src={pg}/>
                            <h4><strong>Prajakta Gogate</strong><br/>Manifestation Coach</h4>
                            <p>  Hey Hi, I’m Prajakta, manifestation coach. I help people realise their power to manifest whatever they want by going beyond their limiting beliefs. I do this via WhatsApp programs, one to one coaching, Facebook group. I’m on mission to transform at least 5000 lives in next one year by helping them build an Abundance Mindset!</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>
    <section className="imageblock switchable feature-large bg--grey">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <h3> Join the community for regular tips and lessons on manifesting dream life!</h3>
                            <h4> Get tips on all things and blogging delivered straight to your inbox, so you never miss out!</h4>
                            <form id="my-form" className="ajaxForm" action="https://formspree.io/xbjzqrep" method="POST" accept-charset="UTF-8"
                              data-success="Thanks for your enquiry, we'll be in touch shortly."
                              data-error="Please fill in all fields correctly.">
                            <div className="col-sm-6 col-xs-12"><label>Your Name:</label> <input type="text" name="Name"
                                                                                             className="validate-required" required/>
                            </div>
                            <div className="col-sm-6 col-xs-12"><label>Email Address:</label> <input type="email"
                                                                                                 name="Email"
                                                                                                 className="validate-required validate-email" required/>
                            </div>
                            <div className="col-sm-5 col-md-4 col-xs-6">
                                <button type="submit" data-sitekey="6LfjluEUAAAAAPBPHxxTr1RIX3D3q9NbKbyy8dAE" data-callback='onSubmit' data-action='submit' className="g-recaptcha btn btn--white type--uppercase">Join now</button>
                            </div>
                            <p id="my-form-status"></p>
                        </form>
                        </div>
                    </div>
                </div>
      </section>
      <section className="space--sm">
      <RelatedBlogs/>

        </section>
      <Footer/>

</div>
</Layout>
  )
}

export const pageQuery = graphql`
  query($slug: String!) {
    markdownRemark(frontmatter: { slug: { eq: $slug } }) {
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        slug
        title
        featuredImage {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
      
    }
  }
`